/**
 * Usage: call .fixedLayoutHelper() on a table (columns should have width set in the CSS), 
 *  and it will set the necessary width on the table.
 *  
 * Warning: colspan not supported
 *  
 *  
 * Note: if you change table call $('#table').trigger('refresh')
 */
(function($) {
	$.widget('ui.fixedLayoutHelper', {
		
		options: {
			colWidth: 50			
		},
		
		
		numCols: null,
		tableWidth: null,
		
		_init: function(){
			this._attachRefreshListener();
			this._resize();
		},

		_attachRefreshListener: function(){
			var table = this.element;
			var self = this;
			table.bind('refresh', function(event){
				var target = $(event.target);
				if(target[0] != table[0]){
					return;
				}
				self._resize();
			});
		},
		
		_resize: function(){
			this.numCols = this.element.find('tr:first').find('td,th').size();
			this.tableWidth = Math.round(this.options.colWidth * this.numCols);
			this.element.css('width', this.tableWidth);
		},

		_setOption: function(option, value){
			// call parent _setOption
			$.Widget.prototype._setOption.apply( this, arguments );  
			
			// refresh on change column width
			if(option == 'colWidth'){
				this.element.trigger('refresh');
			}
		},
		
		/**
		 * @return int column index at documentX, or closest match
		 */
		getColIndex: function(documentX){
			var firstCell = this.element.find('tr:first').children(':first');
			var firstCellDocumentX = firstCell.offset().left;
			
			if(documentX < firstCellDocumentX) return 0;
			if(documentX > firstCellDocumentX + this.tableWidth) return this.numCols - 1;
			
			return Math.floor((documentX - firstCellDocumentX) / this.options.colWidth);
		},
		
		/**
		 * @return int table width in px
		 */
		getTableWidth: function(){
			return this.tableWidth;
		},
				
		/**
		 * @return int
		 */
		getNumCols: function(){
			return this.numCols;
		}
		
	});

	
})(jQuery);